import { initProjectConfirmModal } from './project-confirm-modal.js';

function bindExclusiveAccordion(containerSelector, itemSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) {
        return;
    }

    const items = container.querySelectorAll(itemSelector);
    items.forEach(function (details) {
        details.addEventListener('toggle', function () {
            if (!details.open) {
                return;
            }

            items.forEach(function (other) {
                if (other !== details) {
                    other.open = false;
                }
            });
        });
    });
}

function bindDashboardProjectConfirm(confirmOpen) {
    if (!confirmOpen) {
        return;
    }

    const winnerForm = document.querySelector('.js-winner-hidden-form');

    document.querySelectorAll('.js-winner-btn').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            if (btn.hasAttribute('disabled')) {
                e.preventDefault();
                return;
            }

            e.preventDefault();

            const message = btn.getAttribute('data-confirm') || 'Confirmez-vous vouloir choisir ce gagnant ?';
            confirmOpen(message).then(function (confirmed) {
                if (!confirmed || !winnerForm) {
                    return;
                }

                const pidInput = winnerForm.querySelector('input[name="project_id"]');
                const winInput = winnerForm.querySelector('input[name="winner_user_id"]');
                if (pidInput && winInput) {
                    pidInput.value = btn.getAttribute('data-project') || '';
                    winInput.value = btn.getAttribute('data-winner') || '';
                    winnerForm.submit();
                }
            });
        });
    });

    document.querySelectorAll('.project-board__close-form').forEach(function (form) {
        form.addEventListener('submit', function (e) {
            if (form.dataset.confirmBypass === '1') {
                delete form.dataset.confirmBypass;
                return;
            }

            e.preventDefault();

            const message = form.getAttribute('data-confirm-message')
                || 'Êtes-vous sûr de vouloir fermer ce projet ? Vous ne pourrez plus y faire suite.';

            confirmOpen(message).then(function (confirmed) {
                if (confirmed) {
                    form.dataset.confirmBypass = '1';
                    form.submit();
                }
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('.tableau-de-bord')) {
        return;
    }

    bindExclusiveAccordion('.accordion--project-board', '.accordion__item');
    bindDashboardProjectConfirm(initProjectConfirmModal());
});
